import { createContext, useContext, useState, useEffect } from "react";

const ThemeContext = createContext({ theme: "default", toggleTheme: () => {} });

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => localStorage.getItem("legalai-theme") || "default");

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme === "luxury" ? "luxury" : "");
    localStorage.setItem("legalai-theme", theme);
  }, [theme]);

  const toggleTheme = () => setTheme(t => t === "luxury" ? "default" : "luxury");

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
